 <!-- start : header section -->
 
 
<template>
 <header class="header">
    <div class="wrap-content">
        <nav class="navbar container">
            <router-link class="navbar-brand" to="/">
                <img src="/img/brand/new_logo.png" class="logo d-inline-block align-top" alt="">
            </router-link>
            <div class="btn-mobile btn-top-toggle visible-mobile"
                :class="{active: navi}">
                <i class="fas fa-bars" @click="navi = true"></i>
                <i class="fas fa-times" @click="navi = false"></i>
            </div>
            <div class="top-nav-wrap"
                :class="{active: navi}">
                <ul class="top-nav-menu">
                    <!-- <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            수학여우 소개
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <li><a class="dropdown-item" href="#">브랜드 소개</a></li>
                            <li><a class="dropdown-item" href="#">학생 인터뷰</a></li>
                            <li><a class="dropdown-item" href="#">원장 인터뷰</a></li>
                        </ul>
                        <router-link to="/" class="nav-link">수학여우 소개</router-link>
                    </li> -->
                    <li class="nav-item">
                        <dropdown-menu menu-title="수학여우 소개" class="nav-link menu">
                            <section class="option nav-link">
                                <a href="/?#section-2" class="nav-link" style="color:black !important;">브랜드 소개</a>
                            </section>
                            <section class="option nav-link">
                                <a href="/?#section-5" class="nav-link"  style="color:black !important;">수학여우 콘텐츠</a>
                            </section>
                            <section class="option nav-link">
                                <a href="/?#section-3"  style="color:black !important;">학생 인터뷰</a>
                            </section>
                            <section class="option nav-link">
                                <a href="/?#section-4"  style="color:black !important;">원장 인터뷰</a>
                            </section>
                        </dropdown-menu>
                    </li>
                    <li class="nav-item">
                        <router-link to="/franchisee" class="nav-link">가맹안내</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/noticemain" class="nav-link">게시판</router-link>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link active" href="http://student.mathfox.kr" target="_blank">학습센터</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link active" href="http://admin.mathfox.kr/login" target="_blank">가맹 교육원</a>
                    </li>
                    <li class="nav-item active"
                        :class="{active: $route.path.includes('/test')}">
                        <router-link to="/test/form" class="nav-link">진단 테스트</router-link>
                    </li>
                    <!-- <li class="nav-item">
                        <a class="nav-link" href="https://blog.naver.com/PostList.nhn?blogId=victorywan1&from=postList&categoryNo=7" target="_blank">설명회 일정</a>
                    </li> -->
                    <!-- <li class="nav-item ">
                        <a href="https://www.instagram.com/mathfox_official/" target="_blank">
                            <icon-base
                                viewBox="0 0 40 40"
                                width="40"
                                height="50"
                                iconColor="#285a78"
                                icon-name="instagram"
                            >
                                <icon-instagram></icon-instagram>
                            </icon-base>
                        </a>
                    </li>
                    <li class="nav-item ml-0">
                        <a href="https://blog.naver.com/victorywan1" target="_blank">
                            <icon-base
                                viewBox="0 0 132.97 132.98"
                                width="24"
                                height="50"
                                icon-name="instagram"
                            >
                                <icon-naver-blog 
                                />
                            </icon-base>
                        </a>
                    </li> -->
                </ul>
            </div>
        </nav>
    </div> <!-- /.wrap-content -->
</header> <!-- /.header -->
</template>
<!-- end : header section -->


<script>

import dropdownMenu from '@mmmrks/vue-dropdown-menu'

export default {
    
  name: 'DarkHeader',

  components: {
        dropdownMenu
    },

    data() {
        return {
            navi: false
        }
    },
    watch: {
        '$route': function () {
            this.navi = false
        }
    },
}
</script>


<style>
@media (max-width: 991.99px) {
    .top-nav-wrap {
        top: 110px;
        height: calc(100vh - 110px);
    }
}
.nav-item.active .nav-link, .nav-link.active {
    color: white;
}
.footer-link {
    color: #fff;
}
.footer-link:hover {
    color: #ff946e;
}
.dropDownMenuWrapper {
    border: none !important;
    width: 150px !important;
    height: 49px !important;
    box-shadow: none !important;
    background: transparent !important;
}
.dropDownMenuWrapper .iconWrapper {
    display: none !important;
}
.dropDownMenuWrapper .dropDownMenuButton {
    padding: 0 !important;
    color: inherit;
}
</style>
